export default "__VITE_ASSET__7e0d047e__"